import clsx from "clsx";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { type CourseId, isChildrenShortCourse, Status } from "~/common/courses";
import type { TPatient } from "~/types/patient";

export function PatientStatusBadge({
  status,
  index = 0,
  course_id,
}: {
  status: TPatient["status"];
  index?: number;
  course_id?: CourseId | null;
}) {
  const intl = useIntl();
  let color: StatusBadgeColor;

  switch (status) {
    case Status.TREATMENT_FINISHED:
    case Status.CANCEL_TREATMENT:
      color = "grey";
      break;
    case Status.WAITING_FOR_A_PAYMENT:
    case Status.UNFILLED_CASE:
    case Status._3D_PLAN_APPROVAL:
    case Status.RETAKE_IMPRESSIONS:
    case Status.RETAINERS_RETAKE_IMPRESSIONS:
    case Status.RETAINERS_WAITING_FOR_A_PAYMENT:
      color = "red";
      break;
    default:
      color = "green";
      break;
  }

  return (
    <StatusBadge color={color}>
      {index > 0 && status == Status.UNFILLED_CASE
        ? `${intl.formatMessage({
            id: isChildrenShortCourse(course_id)
              ? "pat.block.right.additional_course"
              : "correction",
          })} ${index} - `
        : null}
      <FormattedMessage id={status} />
    </StatusBadge>
  );
}

type StatusBadgeColor = "red" | "green" | "grey";

export function StatusBadge({
  color,
  children,
}: React.PropsWithChildren<{ color: StatusBadgeColor }>) {
  const classNames = {
    red: "bg-red",
    green: "bg-green",
    grey: "bg-grey tw-bg-gray-400",
  };

  return (
    <span className={clsx("label label-sm tw-rounded-[3px] tw-font-normal", classNames[color])}>
      {children}
    </span>
  );
}
